export const ClassNameOfViewPopout = "FloatingMenu_ViewPopout";
